var expand = function (hex) {
    var h = hex.startsWith("#") ? hex.slice(1) : hex;
    if (h.length === 3) {
        return h
            .split("")
            .map(function (c) { return c + c; })
            .join("");
    }
    return h;
};
var parseRgb = function (hex) {
    var h = expand(hex);
    if (h.length !== 6)
        return null;
    var r = parseInt(h.slice(0, 2), 16);
    var g = parseInt(h.slice(2, 4), 16);
    var b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some(function (v) { return Number.isNaN(v); }))
        return null;
    return { r: r, g: g, b: b };
};
// YIQ-based perceived brightness (0-255). Threshold ~140 picks dark text
// slightly more aggressively than the canonical 128 — it tends to read better
// on borderline mids like sky-blue or olive.
var YIQ_THRESHOLD = 140;
export var isLightColor = function (hex) {
    var rgb = parseRgb(hex);
    if (!rgb)
        return false;
    var yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= YIQ_THRESHOLD;
};
export var contrastText = function (bgHex) {
    return isLightColor(bgHex) ? "#0a0a0a" : "#ffffff";
};
